/**
 * OFFIX B2B Quote List Engine
 * Fully decoupled from Shopify Cart/Checkout.
 * Powered by localStorage ("offix_quote_list").
 */
(function() {
  'use strict';

  const STORAGE_KEY = 'offix_quote_list';
  let memoryStorage = [];

  // Safe localStorage helper
  const storage = {
    get() {
      try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        return memoryStorage;
      }
    },
    set(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {
        memoryStorage = items;
      }
    }
  };

  const OfFixQuoteList = {
    getItems() {
      const items = storage.get();
      return Array.isArray(items) ? items : [];
    },

    saveItems(items) {
      storage.set(items);
      this.updateBadges();
      this.renderDrawer();
      document.dispatchEvent(new CustomEvent('quote-list:updated', { detail: { items } }));
    },

    addItem(newItem) {
      if (!newItem || !newItem.productId) return;
      const items = this.getItems();
      const pId = String(newItem.productId);
      const vId = newItem.variantId ? String(newItem.variantId) : '';
      const qty = parseInt(newItem.quantity, 10) || 1;

      const existingIndex = items.findIndex(item => {
        const itemPId = String(item.productId);
        const itemVId = item.variantId ? String(item.variantId) : '';
        return itemPId === pId && itemVId === vId;
      });

      if (existingIndex > -1) {
        items[existingIndex].quantity = (parseInt(items[existingIndex].quantity, 10) || 1) + qty;
        if (newItem.image && !items[existingIndex].image) items[existingIndex].image = newItem.image;
        if (newItem.url && !items[existingIndex].url) items[existingIndex].url = newItem.url;
      } else {
        items.push({
          productId: newItem.productId,
          variantId: newItem.variantId || '',
          title: newItem.title || 'Office Furniture Item',
          variantTitle: (newItem.variantTitle && newItem.variantTitle !== 'Default Title') ? newItem.variantTitle : '',
          image: newItem.image || '',
          url: newItem.url || '/collections/all',
          quantity: qty
        });
      }

      this.saveItems(items);
    },

    addToQuoteList(sourceEl, optionalQty) {
      if (!sourceEl) return null;
      const el = (sourceEl instanceof Element) ? sourceEl : document.querySelector(sourceEl);
      if (!el) return null;

      const productSection = el.closest('[data-section-type="product-detail"]');
      const card = el.closest('[data-product-card], [data-product-quick-add], .product-card');

      if (card && (card.classList.contains('is-sold-out') || el.hasAttribute('disabled') || el.classList.contains('is-disabled'))) {
        return null;
      }

      let item = null;

      if (productSection) {
        let productData = null;
        try {
          const raw = productSection.getAttribute('data-product-json');
          productData = raw ? JSON.parse(raw) : null;
        } catch (err) {}

        const variantSelect = productSection.querySelector('[data-variant-select]');
        const activeVariantId = variantSelect ? variantSelect.value : (productData && productData.variants && productData.variants[0] ? productData.variants[0].id : '');
        let activeVariantTitle = '';
        if (variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions[0]) {
          activeVariantTitle = variantSelect.selectedOptions[0].textContent.trim();
        }

        const sliderInput = productSection.querySelector('[data-qty-input], [data-slider-input], [data-qty-range], input[type="range"]');
        const qty = optionalQty || (sliderInput ? parseInt(sliderInput.value, 10) : 1);

        const mainImg = productSection.querySelector('#product-main-image, .product-detail__main-image img');
        const imgUrl = mainImg ? mainImg.src : (productData ? productData.featured_image : '');

        item = {
          productId: productData ? productData.id : Date.now(),
          variantId: activeVariantId,
          title: productData ? productData.title : (document.querySelector('.product-detail__title')?.textContent?.trim() || 'OFFIX Product'),
          variantTitle: (activeVariantTitle && activeVariantTitle !== 'Default Title') ? activeVariantTitle : '',
          image: imgUrl,
          url: window.location.pathname,
          quantity: qty
        };
      } else if (card) {
        const pId = card.getAttribute('data-product-id');
        const vId = card.getAttribute('data-variant-id');
        const pTitle = card.getAttribute('data-product-title');
        const pImg = card.getAttribute('data-product-image');
        const pUrl = card.getAttribute('data-product-url');

        const sliderInput = card.querySelector('[data-qty-input], [data-slider-input], input[type="range"]');
        const qty = optionalQty || (sliderInput ? parseInt(sliderInput.value, 10) : (parseInt(card.getAttribute('data-selected-qty'), 10) || 1));

        if (pId && pTitle) {
          item = {
            productId: pId,
            variantId: vId || '',
            title: pTitle,
            variantTitle: '',
            image: pImg || card.querySelector('img')?.src || '',
            url: pUrl || card.querySelector('a')?.getAttribute('href') || '/collections/all',
            quantity: qty
          };
        } else {
          let cardData = null;
          try {
            const raw = card.getAttribute('data-product');
            cardData = raw ? JSON.parse(raw) : null;
          } catch (err) {}

          if (cardData) {
            item = {
              productId: cardData.id || cardData.productId,
              variantId: cardData.variantId || '',
              title: cardData.title,
              variantTitle: cardData.variantTitle || '',
              image: cardData.image || card.querySelector('img')?.src || '',
              url: cardData.url || '/collections/all',
              quantity: qty
            };
          } else {
            const title = el.getAttribute('data-title') || card.querySelector('.product-card__name, .product-card__title')?.textContent?.trim() || 'OFFIX Furniture';
            const variantTitle = el.getAttribute('data-variant') || '';
            const img = card.querySelector('img')?.src || '';
            const fallbackId = el.getAttribute('data-product-id') || title.replace(/\s+/g, '-').toLowerCase();

            item = {
              productId: fallbackId,
              variantId: variantTitle,
              title: title,
              variantTitle: variantTitle,
              image: img,
              url: card.querySelector('a')?.getAttribute('href') || '/collections/all',
              quantity: qty
            };
          }
        }
      }

      if (item) {
        this.addItem(item);
      }

      return item;
    },

    updateQuantity(productId, variantId, quantity) {
      const pId = String(productId);
      const vId = variantId ? String(variantId) : '';
      const qty = parseInt(quantity, 10);
      let items = this.getItems();

      if (qty <= 0) {
        items = items.filter(item => !(String(item.productId) === pId && (item.variantId ? String(item.variantId) : '') === vId));
      } else {
        const target = items.find(item => String(item.productId) === pId && (item.variantId ? String(item.variantId) : '') === vId);
        if (target) {
          target.quantity = qty;
        }
      }

      this.saveItems(items);
    },

    removeItem(productId, variantId) {
      this.updateQuantity(productId, variantId, 0);
    },

    clearList() {
      this.saveItems([]);
    },

    getTotalQuantity() {
      const items = this.getItems();
      return items.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 1), 0);
    },

    updateBadges() {
      const count = this.getTotalQuantity();
      const badges = document.querySelectorAll('[data-quote-count], [data-cart-count]');
      badges.forEach(badge => {
        badge.textContent = count;
        badge.setAttribute('data-count', count);
        badge.classList.remove('badge-pulse');
        void badge.offsetWidth;
        badge.classList.add('badge-pulse');
      });
    },

    openDrawer() {
      const drawer = document.querySelector('[data-cart-drawer], [data-quote-drawer]');
      if (!drawer) return;
      this.renderDrawer();
      drawer.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
    },

    closeDrawer() {
      const drawer = document.querySelector('[data-cart-drawer], [data-quote-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    },

    renderDrawer() {
      const container = document.querySelector('[data-quote-list-items], [data-cart-items]');
      const emptyEl = document.querySelector('[data-quote-empty], [data-cart-empty]');
      const footerEl = document.querySelector('[data-cart-drawer-footer]');
      const items = this.getItems();

      if (!container) return;

      if (items.length === 0) {
        container.innerHTML = '';
        container.style.display = 'none';
        if (emptyEl) emptyEl.classList.remove('u-visually-hidden');
        if (footerEl) footerEl.classList.add('u-visually-hidden');
        return;
      }

      if (emptyEl) emptyEl.classList.add('u-visually-hidden');
      if (footerEl) footerEl.classList.remove('u-visually-hidden');
      container.style.display = 'block';

      let html = '';
      items.forEach(item => {
        const vTitle = item.variantTitle ? `<span class="quote-drawer__item-sku">${escapeHtml(item.variantTitle)}</span>` : '';
        const imgTag = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" class="quote-drawer__thumb" loading="lazy">`
          : `<div class="quote-drawer__thumb-placeholder">OFFIX</div>`;

        html += `
          <div class="quote-drawer__item" data-product-id="${escapeHtml(item.productId)}" data-variant-id="${escapeHtml(item.variantId)}">
            <a href="${escapeHtml(item.url)}" class="quote-drawer__media">
              ${imgTag}
            </a>
            <div class="quote-drawer__info">
              <a href="${escapeHtml(item.url)}" class="quote-drawer__title">${escapeHtml(item.title)}</a>
              ${vTitle}
              <div class="quote-drawer__controls">
                <div class="quote-drawer__stepper">
                  <button type="button" class="quote-drawer__step-btn" data-action="qty-minus" aria-label="Decrease quantity">&minus;</button>
                  <input type="number" class="quote-drawer__qty-input" value="${item.quantity}" min="1" max="999" data-action="qty-input" aria-label="Quantity">
                  <button type="button" class="quote-drawer__step-btn" data-action="qty-plus" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="quote-drawer__remove-btn" data-action="remove-item" aria-label="Remove item">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                  <span class="quote-drawer__remove-label">Remove</span>
                </button>
              </div>
            </div>
          </div>
        `;
      });

      container.innerHTML = html;
    },

    sendWhatsAppQuote() {
      const items = this.getItems();
      if (items.length === 0) return;

      let msg = "Hi OFFIX, I'd like a quote for:\n\n";
      items.forEach((item, i) => {
        const variantPart = item.variantTitle ? ` (${item.variantTitle})` : '';
        msg += `${i + 1}. ${item.title}${variantPart} — Qty: ${item.quantity}\n`;
      });
      msg += "\nPlease share pricing & availability. Thank you!";

      const rawNumber = document.body.getAttribute('data-whatsapp-number') || (window.themeSettings && window.themeSettings.whatsappNumber) || '923225545791';
      const cleanNumber = String(rawNumber).replace(/[^\d]/g, '');
      const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(msg)}`;
      window.open(url, '_blank', 'noopener');
    }
  };

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Bind all interactive events
  document.addEventListener('DOMContentLoaded', function() {
    // Initial badge & drawer sync
    OfFixQuoteList.updateBadges();
    OfFixQuoteList.renderDrawer();

    // ============================================================================
    // Global Confirmation Toast Component (#GlobalQuoteToast)
    // ============================================================================
    const GlobalQuoteToast = {
      timeoutId: null,

      init() {
        if (document.getElementById('GlobalQuoteToast')) return;
        const toast = document.createElement('div');
        toast.id = 'GlobalQuoteToast';
        toast.className = 'global-quote-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.innerHTML = `
          <div class="global-quote-toast__inner">
            <div class="global-quote-toast__icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <div class="global-quote-toast__body">
              <span class="global-quote-toast__msg" data-toast-msg>Item added to quote list</span>
              <button type="button" class="global-quote-toast__view-btn" data-action="open-quote-list">View list &rarr;</button>
            </div>
            <button type="button" class="global-quote-toast__close" aria-label="Dismiss notification">&times;</button>
          </div>
        `;
        document.body.appendChild(toast);

        // Hover & focus pause handling
        toast.addEventListener('mouseenter', () => this.pause());
        toast.addEventListener('mouseleave', () => this.resume());
        toast.addEventListener('focusin', () => this.pause());
        toast.addEventListener('focusout', () => this.resume());

        toast.querySelector('.global-quote-toast__close').addEventListener('click', (e) => {
          e.preventDefault();
          this.hide();
        });
      },

      show(quantity, title, isUpdate = false) {
        this.init();
        const toast = document.getElementById('GlobalQuoteToast');
        if (!toast) return;

        const msgEl = toast.querySelector('[data-toast-msg]');
        const actionVerb = isUpdate ? 'updated in quote list' : 'added to quote list';
        if (msgEl) {
          msgEl.innerHTML = `<strong>${quantity} &times; ${title}</strong> ${actionVerb}`;
        }

        clearTimeout(this.timeoutId);
        toast.classList.remove('is-active');
        void toast.offsetWidth; // force reflow
        toast.classList.add('is-active');
        document.body.classList.add('quote-toast-active');

        this.timeoutId = setTimeout(() => this.hide(), 5000);
      },

      pause() {
        clearTimeout(this.timeoutId);
      },

      resume() {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => this.hide(), 3000);
      },

      hide() {
        const toast = document.getElementById('GlobalQuoteToast');
        if (toast) {
          toast.classList.remove('is-active');
          document.body.classList.remove('quote-toast-active');
        }
        clearTimeout(this.timeoutId);
      }
    };

    // ============================================================================
    // B2B Card Quantity & Single Source of Truth Engine
    // ============================================================================
    const CardQuantityManager = {
      init() {
        this.bindEvents();
        this.syncAllCards();
        document.addEventListener('quote-list:updated', () => this.syncAllCards());
      },

      setCardQuantity(card, rawQty) {
        if (!card) return;
        let qty = parseInt(rawQty, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        if (qty > 9999) qty = 9999;

        card.setAttribute('data-selected-qty', qty);

        // 1. Live text readout
        const liveVal = card.querySelector('[data-qty-live-val]');
        if (liveVal) {
          if (qty === 1) {
            liveVal.textContent = '1 pc';
          } else if (qty >= 10) {
            liveVal.textContent = '10+ pcs';
          } else {
            liveVal.textContent = qty + ' pcs';
          }
        }

        // 2. Desktop Range Slider (1-10)
        const rangeSlider = card.querySelector('[data-range-slider]');
        if (rangeSlider) {
          const sliderVal = Math.min(qty, 10);
          rangeSlider.value = sliderVal;
          rangeSlider.setAttribute('aria-valuetext', qty + ' pieces');
          
          // Update visual filled track via gradient
          const pct = ((sliderVal - 1) / 9) * 100;
          rangeSlider.style.background = `linear-gradient(to right, #E0693A 0%, #E0693A ${pct}%, #E8E3DC ${pct}%, #E8E3DC 100%)`;
        }

        // 3. Mobile Stepper Input
        const stepperInput = card.querySelector('[data-stepper-input]');
        if (stepperInput && stepperInput !== document.activeElement) {
          stepperInput.value = qty;
        }

        // 4. Bulk Mode Container (10+)
        const bulkContainer = card.querySelector('[data-bulk-container]');
        const exactInput = card.querySelector('[data-exact-input]');
        const bulkWaLink = card.querySelector('[data-bulk-wa-link]');
        const pTitle = card.getAttribute('data-product-title') || 'OFFIX Item';
        const pUrl = card.getAttribute('data-product-url') || window.location.href;
        const shopOrigin = window.location.origin;
        const fullUrl = pUrl.startsWith('http') ? pUrl : (shopOrigin + pUrl);
        const waNumber = (window.themeSettings && window.themeSettings.whatsappNumber) 
          ? window.themeSettings.whatsappNumber.replace(/[^0-9]/g, '') 
          : '923225545791';

        if (qty >= 10) {
          if (bulkContainer) bulkContainer.style.display = 'block';
          if (exactInput && exactInput !== document.activeElement) {
            exactInput.value = qty;
          }
          if (bulkWaLink) {
            const bulkMsg = `Hi OFFIX, I would like to request a bulk commercial quote for ${pTitle} (Quantity: ${qty} units): ${fullUrl}`;
            bulkWaLink.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(bulkMsg)}`;
          }
        } else {
          if (bulkContainer) bulkContainer.style.display = 'none';
        }

        // 5. Update Secondary Card WhatsApp Button Prefill
        const waBtn = card.querySelector('[data-action="wa-inquire"]');
        if (waBtn) {
          const waMsg = `Hi OFFIX, I would like to inquire about ${pTitle} (Quantity: ${qty} units): ${fullUrl}`;
          waBtn.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMsg)}`;
        }

        // 6. Lockstep Qty Sync for added card (transfers to "Update quote" on slider/stepper change)
        if (!card._isSyncing) {
          const quoteBtn = card.querySelector('[data-action="add-to-quote-list"]');
          const editBtn = card.querySelector('[data-action="edit-quote-qty"]');
          const pId = card.getAttribute('data-product-id');
          const vId = card.getAttribute('data-variant-id') || '';
          const items = OfFixQuoteList.getItems();
          const existing = items.find(it => String(it.productId) === String(pId) && String(it.variantId || '') === String(vId));

          if (quoteBtn && existing) {
            const defContent = quoteBtn.querySelector('.product-card__btn-content-default');
            const addContent = quoteBtn.querySelector('.product-card__btn-content-added');
            const addLabel = quoteBtn.querySelector('[data-added-label]');
            const defLabel = quoteBtn.querySelector('.product-card__btn-label');

            const setLabelText = (txt) => {
              if (!defLabel) return;
              const d = defLabel.querySelector('.product-card__btn-label--desktop');
              const m = defLabel.querySelector('.product-card__btn-label--mobile');
              if (d && m) {
                d.textContent = txt;
                m.textContent = txt;
              } else {
                defLabel.textContent = txt;
              }
            };

            if (qty === existing.quantity) {
              quoteBtn.classList.add('is-added');
              quoteBtn.classList.remove('is-updating');
              if (defContent) defContent.style.display = 'none';
              if (addContent) addContent.style.display = 'inline-flex';
              if (addLabel) addLabel.textContent = `Added (${existing.quantity})`;
              if (editBtn) editBtn.style.display = 'inline-block';
            } else {
              // Qty moved away from stored item -> transition to Update quote
              quoteBtn.classList.remove('is-added');
              quoteBtn.classList.add('is-updating');
              if (addContent) addContent.style.display = 'none';
              if (defContent) {
                defContent.style.display = 'inline-flex';
                setLabelText('Update quote');
              }
              if (editBtn) editBtn.style.display = 'none';
            }
          }
        }
      },

      bindEvents() {
        // Step buttons: Decrease & Increase
        document.addEventListener('click', (e) => {
          const minusBtn = e.target.closest('[data-action="decrease-qty"]');
          if (minusBtn) {
            e.preventDefault();
            const card = minusBtn.closest('[data-product-card]');
            if (!card) return;
            const current = parseInt(card.getAttribute('data-selected-qty'), 10) || 1;
            this.setCardQuantity(card, current - 1);
            return;
          }

          const plusBtn = e.target.closest('[data-action="increase-qty"]');
          if (plusBtn) {
            e.preventDefault();
            const card = plusBtn.closest('[data-product-card]');
            if (!card) return;
            const current = parseInt(card.getAttribute('data-selected-qty'), 10) || 1;
            this.setCardQuantity(card, current + 1);
            return;
          }
        });

        // Range slider input
        document.addEventListener('input', (e) => {
          if (e.target && e.target.matches('[data-range-slider]')) {
            const card = e.target.closest('[data-product-card]');
            if (card) this.setCardQuantity(card, e.target.value);
          }
        });

        // Mobile stepper numeric input
        document.addEventListener('input', (e) => {
          if (e.target && e.target.matches('[data-stepper-input]')) {
            const card = e.target.closest('[data-product-card]');
            if (card) this.setCardQuantity(card, e.target.value);
          }
        });

        // Exact bulk quantity input
        document.addEventListener('input', (e) => {
          if (e.target && e.target.matches('[data-exact-input]')) {
            const card = e.target.closest('[data-product-card]');
            if (card) {
              const val = parseInt(e.target.value, 10);
              if (!isNaN(val)) {
                this.setCardQuantity(card, val);
              }
            }
          }
        });

        // Add to Quote List & Update Quote Button Handler
        document.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-action="add-to-quote-list"]');
          if (!btn) return;
          if (btn.hasAttribute('disabled') || btn.classList.contains('is-disabled')) return;

          const card = btn.closest('[data-product-card]');
          if (!card || card.classList.contains('is-sold-out')) return;

          e.preventDefault();

          const pId = card.getAttribute('data-product-id');
          const vId = card.getAttribute('data-variant-id') || '';
          const pTitle = card.getAttribute('data-product-title') || 'OFFIX Item';
          const qty = parseInt(card.getAttribute('data-selected-qty'), 10) || 1;

          // Check if button is currently in "Update quote" editing state
          const isUpdating = btn.classList.contains('is-updating');

          // Show inline spinner briefly
          const spinner = btn.querySelector('.product-card__btn-spinner');
          const defContent = btn.querySelector('.product-card__btn-content-default');
          const addContent = btn.querySelector('.product-card__btn-content-added');
          const addLabel = btn.querySelector('[data-added-label]');
          const editBtn = card.querySelector('[data-action="edit-quote-qty"]');

          if (spinner) spinner.style.display = 'inline-block';
          if (defContent) defContent.style.display = 'none';
          if (addContent) addContent.style.display = 'none';
          btn.setAttribute('disabled', 'disabled');

          setTimeout(() => {
            if (spinner) spinner.style.display = 'none';
            btn.removeAttribute('disabled');

            if (isUpdating) {
              // Update existing line item in quote list
              OfFixQuoteList.updateQuantity(pId, vId, qty);
              btn.classList.remove('is-updating');
              btn.classList.add('is-added');
              if (addLabel) addLabel.textContent = `Added (${qty})`;
              if (addContent) addContent.style.display = 'inline-flex';
              if (editBtn) editBtn.style.display = 'inline-block';
              GlobalQuoteToast.show(qty, pTitle, true);
            } else {
              // Add to quote list
              OfFixQuoteList.addToQuoteList(btn, qty);
              btn.classList.add('is-added');
              if (addLabel) addLabel.textContent = `Added (${qty})`;
              if (addContent) addContent.style.display = 'inline-flex';
              if (editBtn) editBtn.style.display = 'inline-block';
              GlobalQuoteToast.show(qty, pTitle, false);
            }

            // Pulse header badge
            const badges = document.querySelectorAll('[data-quote-count], [data-cart-count]');
            badges.forEach(b => {
              b.classList.remove('is-pulsing');
              void b.offsetWidth;
              b.classList.add('is-pulsing');
            });
          }, 250);
        });

        // Edit Quote Quantity Button Handler
        document.addEventListener('click', (e) => {
          const editBtn = e.target.closest('[data-action="edit-quote-qty"]');
          if (!editBtn) return;
          e.preventDefault();

          const card = editBtn.closest('[data-product-card]');
          if (!card) return;

          const quoteBtn = card.querySelector('[data-action="add-to-quote-list"]');
          if (!quoteBtn) return;

          quoteBtn.classList.remove('is-added');
          quoteBtn.classList.add('is-updating');

          const defContent = quoteBtn.querySelector('.product-card__btn-content-default');
          const addContent = quoteBtn.querySelector('.product-card__btn-content-added');
          const defLabel = quoteBtn.querySelector('.product-card__btn-label');

          if (addContent) addContent.style.display = 'none';
          if (defContent) {
            defContent.style.display = 'inline-flex';
            if (defLabel) {
              const d = defLabel.querySelector('.product-card__btn-label--desktop');
              const m = defLabel.querySelector('.product-card__btn-label--mobile');
              if (d && m) {
                d.textContent = 'Update quote';
                m.textContent = 'Update quote';
              } else {
                defLabel.textContent = 'Update quote';
              }
            }
          }
          editBtn.style.display = 'none';

          // Focus slider or stepper for instant editing
          const slider = card.querySelector('[data-range-slider]');
          if (slider && window.innerWidth >= 768) {
            slider.focus();
          } else {
            const stepper = card.querySelector('[data-stepper-input]');
            if (stepper) stepper.focus();
          }
        });
      },

      syncAllCards() {
        const items = OfFixQuoteList.getItems();
        document.querySelectorAll('[data-product-card]').forEach(card => {
          card._isSyncing = true;
          const pId = card.getAttribute('data-product-id');
          const vId = card.getAttribute('data-variant-id') || '';
          
          const existing = items.find(it => String(it.productId) === String(pId) && String(it.variantId || '') === String(vId));
          const quoteBtn = card.querySelector('[data-action="add-to-quote-list"]');
          const editBtn = card.querySelector('[data-action="edit-quote-qty"]');

          const defQty = existing ? existing.quantity : (parseInt(card.getAttribute('data-default-qty'), 10) || 1);
          this.setCardQuantity(card, defQty);

          const defContent = quoteBtn ? quoteBtn.querySelector('.product-card__btn-content-default') : null;
          const addContent = quoteBtn ? quoteBtn.querySelector('.product-card__btn-content-added') : null;
          const addLabel = quoteBtn ? quoteBtn.querySelector('[data-added-label]') : null;
          const defLabel = quoteBtn ? quoteBtn.querySelector('.product-card__btn-label') : null;

          const resetLabelText = () => {
            if (!defLabel) return;
            const d = defLabel.querySelector('.product-card__btn-label--desktop');
            const m = defLabel.querySelector('.product-card__btn-label--mobile');
            if (d && m) {
              d.textContent = 'Add to quote list';
              m.textContent = 'Add to quote';
            } else {
              defLabel.textContent = 'Add to quote list';
            }
          };

          if (existing && quoteBtn) {
            quoteBtn.classList.add('is-added');
            quoteBtn.classList.remove('is-updating');
            if (defContent) defContent.style.display = 'none';
            if (addContent) addContent.style.display = 'inline-flex';
            if (addLabel) addLabel.textContent = `Added (${existing.quantity})`;
            if (editBtn) editBtn.style.display = 'inline-block';
          } else if (quoteBtn) {
            quoteBtn.classList.remove('is-added', 'is-updating');
            if (defContent) {
              defContent.style.display = 'inline-flex';
              resetLabelText();
            }
            if (addContent) addContent.style.display = 'none';
            if (editBtn) editBtn.style.display = 'none';
          }
          card._isSyncing = false;
        });
      }
    };

    // Initialize Card Quantity Manager on DOM Load
    CardQuantityManager.init();

    // 3. Header Quote List trigger & Drawer controls
    document.addEventListener('click', function(e) {
      // Open
      if (e.target.closest('[data-action="open-quote-list"], [data-action="open-cart"]')) {
        e.preventDefault();
        OfFixQuoteList.openDrawer();
        return;
      }

      // Close
      if (e.target.closest('[data-action="close-quote-list"], [data-action="close-cart"], [data-cart-drawer-overlay]')) {
        e.preventDefault();
        OfFixQuoteList.closeDrawer();
        return;
      }

      // WhatsApp Quote CTA
      if (e.target.closest('[data-action="whatsapp-quote"]')) {
        e.preventDefault();
        OfFixQuoteList.sendWhatsAppQuote();
        return;
      }

      // Clear list with 2-step confirmation
      const clearBtn = e.target.closest('[data-action="clear-quote-list"]');
      if (clearBtn) {
        e.preventDefault();
        const state = clearBtn.getAttribute('data-state') || 'idle';
        const clearText = clearBtn.querySelector('.clear-text');
        const confirmText = clearBtn.querySelector('.confirm-text');

        if (state === 'idle') {
          clearBtn.setAttribute('data-state', 'confirming');
          if (clearText) clearText.style.display = 'none';
          if (confirmText) confirmText.style.display = 'inline';
          clearTimeout(clearBtn._confirmTimeout);
          clearBtn._confirmTimeout = setTimeout(() => {
            clearBtn.setAttribute('data-state', 'idle');
            if (clearText) clearText.style.display = 'inline';
            if (confirmText) confirmText.style.display = 'none';
          }, 3500);
        } else if (state === 'confirming') {
          clearTimeout(clearBtn._confirmTimeout);
          clearBtn.setAttribute('data-state', 'idle');
          if (clearText) clearText.style.display = 'inline';
          if (confirmText) confirmText.style.display = 'none';
          OfFixQuoteList.clearList();
        }
        return;
      } else {
        // Reset any confirming clear button if clicked outside
        const anyConfirmingBtn = document.querySelector('[data-action="clear-quote-list"][data-state="confirming"]');
        if (anyConfirmingBtn) {
          anyConfirmingBtn.setAttribute('data-state', 'idle');
          const clearText = anyConfirmingBtn.querySelector('.clear-text');
          const confirmText = anyConfirmingBtn.querySelector('.confirm-text');
          if (clearText) clearText.style.display = 'inline';
          if (confirmText) confirmText.style.display = 'none';
        }
      }

      // Drawer Item Remove with smooth collapse animation
      const removeBtn = e.target.closest('[data-action="remove-item"]');
      if (removeBtn && removeBtn.closest('.quote-drawer__item')) {
        e.preventDefault();
        const row = removeBtn.closest('.quote-drawer__item');
        const pId = row.getAttribute('data-product-id');
        const vId = row.getAttribute('data-variant-id');
        row.classList.add('is-removing');
        setTimeout(() => {
          OfFixQuoteList.removeItem(pId, vId);
        }, 220);
        return;
      }

      // Drawer Stepper Minus
      const minusBtn = e.target.closest('[data-action="qty-minus"]');
      if (minusBtn) {
        e.preventDefault();
        const row = minusBtn.closest('.quote-drawer__item');
        const pId = row.getAttribute('data-product-id');
        const vId = row.getAttribute('data-variant-id');
        const input = row.querySelector('.quote-drawer__qty-input');
        let val = parseInt(input.value, 10) || 1;
        val = Math.max(1, val - 1);
        input.value = val;
        OfFixQuoteList.updateQuantity(pId, vId, val);
        return;
      }

      // Drawer Stepper Plus
      const plusBtn = e.target.closest('[data-action="qty-plus"]');
      if (plusBtn) {
        e.preventDefault();
        const row = plusBtn.closest('.quote-drawer__item');
        const pId = row.getAttribute('data-product-id');
        const vId = row.getAttribute('data-variant-id');
        const input = row.querySelector('.quote-drawer__qty-input');
        let val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
        OfFixQuoteList.updateQuantity(pId, vId, val);
        return;
      }
    });

    // Drawer manual input change
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('quote-drawer__qty-input')) {
        const row = e.target.closest('.quote-drawer__item');
        const pId = row.getAttribute('data-product-id');
        const vId = row.getAttribute('data-variant-id');
        let val = parseInt(e.target.value, 10) || 1;
        val = Math.max(1, val);
        e.target.value = val;
        OfFixQuoteList.updateQuantity(pId, vId, val);
      }
    });

    // ESC to close drawer
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        OfFixQuoteList.closeDrawer();
      }
    });
  });

  // Expose globally
  window.OfFixQuoteList = OfFixQuoteList;
  window.addToQuoteList = OfFixQuoteList.addToQuoteList.bind(OfFixQuoteList);
})();